// TODO
import { Action } from '@ngrx/store';
import { Definition } from '../definitions/definition.interface';
import { StockCountFilter } from './stock-count-filter.interface';
import { GetStockCountMaterialList, StockCountCreated, StockCountCreateOrderList, StockCountDetail, StockCountList, TOstockCount } from './stock-count.interface';

export const STOCK_COUNTS_FILTER_VALUES_LOAD = 'stock_counts:STOCK_COUNTS_FILTER_VALUES_LOAD';
export const STOCK_COUNTS_FILTER_VALUES_LOAD_FAIL = 'stock_counts:STOCK_COUNTS_FILTER_VALUES_LOAD_FAIL';
export const STOCK_COUNTS_FILTER_VALUES_LOAD_SUCCESS = 'stock_counts:STOCK_COUNTS_FILTER_VALUES_LOAD_SUCCESS';
export const STOCK_COUNTS_FILTER_VALUES = 'stock_counts:STOCK_COUNTS_FILTER_VALUES';

export const STOCK_COUNTS_PAGE_SIZE_UPDATE = 'stock_counts:STOCK_COUNTS_PAGE_SIZE_UPDATE';
export const STOCK_COUNTS_PAGE_NUMBER_UPDATE = 'stock_counts:STOCK_COUNTS_PAGE_NUMBER_UPDATE';

export const STOCK_COUNTS_DETAIL_LOAD = 'stock_counts:STOCK_COUNTS_DETAIL_LOAD';
export const STOCK_COUNTS_DETAIL_LOAD_FAIL = 'stock_counts:STOCK_COUNTS_DETAIL_LOAD_FAIL';
export const STOCK_COUNTS_DETAIL_LOAD_SUCCESS = 'stock_counts:STOCK_COUNTS_DETAIL_LOAD_SUCCESS';
export const STOCK_COUNTS_DETAIL = 'stock_counts:STOCK_COUNTS_DETAIL';

export const STOCK_COUNTS_ORDER_LIST_LOAD = 'stock_counts:STOCK_COUNTS_ORDER_LIST_LOAD';
export const STOCK_COUNTS_ORDER_LIST_LOAD_FAIL = 'stock_counts:STOCK_COUNTS_ORDER_LIST_LOAD_FAIL';
export const STOCK_COUNTS_ORDER_LIST_LOAD_SUCCESS = 'stock_counts:STOCK_COUNTS_ORDER_LIST_LOAD_SUCCESS';
export const STOCK_COUNTS_ORDER_LIST = 'stock_counts:STOCK_COUNTS_ORDER_LIST';

export const STOCK_COUNTS_MATERIAL_LIST_LOAD = 'stock_counts:STOCK_COUNTS_MATERIAL_LIST_LOAD';
export const STOCK_COUNTS_MATERIAL_LIST_LOAD_FAIL = 'stock_counts:STOCK_COUNTS_MATERIAL_LIST_LOAD_FAIL';
export const STOCK_COUNTS_MATERIAL_LIST_LOAD_SUCCESS = 'stock_counts:STOCK_COUNTS_MATERIAL_LIST_LOAD_SUCCESS';
export const STOCK_COUNTS_MATERIAL_LIST = 'stock_counts:STOCK_COUNTS_MATERIAL_LIST';

export const STOCK_COUNTS_CREATE = 'stock_counts:STOCK_COUNTS_CREATE';
export const STOCK_COUNTS_CREATE_FAIL = 'stock_counts:STOCK_COUNTS_CREATE_FAIL';
export const STOCK_COUNTS_CREATE_SUCCESS = 'stock_counts:STOCK_COUNTS_CREATE_SUCCESS';
export const STOCK_COUNTS_CREATE_UI = 'stock_counts:STOCK_COUNTS_CREATE_UI';

export const STOCK_COUNTS_SHIPTO_LOAD = 'stock_counts:STOCK_COUNTS_SHIPTO_LOAD';
export const STOCK_COUNTS_SHIPTO_LOAD_FAIL = 'stock_counts:STOCK_COUNTS_SHIPTO_LOAD_FAIL';
export const STOCK_COUNTS_SHIPTO_LOAD_SUCCESS = 'stock_counts:STOCK_COUNTS_SHIPTO_LOAD_SUCCESS';
export const STOCK_COUNTS_SHIPTO = 'stock_counts:STOCK_COUNTS_SHIPTO';

export const STOCK_COUNTS_CREATE_CANCELED = 'stock_counts:STOCK_COUNTS_CREATE_CANCELED';

export const STOCK_COUNTS_PRINT_LOAD = 'stock_counts:STOCK_COUNTS_PRINT_LOAD';
export const STOCK_COUNTS_PRINT_LOAD_FAIL = 'stock_counts:STOCK_COUNTS_PRINT_LOAD_FAIL';
export const STOCK_COUNTS_PRINT_LOAD_SUCCESS = 'stock_counts:STOCK_COUNTS_PRINT_LOAD_SUCCESS';
export const STOCK_COUNTS_PRINT = 'stock_counts:STOCK_COUNTS_PRINT';

export class StockCountsFilterValuesLoadAction implements Action {
  readonly type = STOCK_COUNTS_FILTER_VALUES_LOAD;
  logPayload = true;

  ui = {
    id: STOCK_COUNTS_FILTER_VALUES,
    busy: true,
  };

  constructor(readonly payload: StockCountFilter) {}
}

export class StockCountsFilterValuesLoadSuccessAction implements Action {
  readonly type = STOCK_COUNTS_FILTER_VALUES_LOAD_SUCCESS;

  ui = {
    id: STOCK_COUNTS_FILTER_VALUES,
    busy: false,
  };

  constructor(readonly payload: StockCountList) {}
}

export class StockCountsFilterValuesLoadFailAction implements Action {
  readonly type = STOCK_COUNTS_FILTER_VALUES_LOAD_FAIL;
  logPayload = true;

  ui = {
    id: STOCK_COUNTS_FILTER_VALUES,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class StockCountsPageSizeUpdate implements Action {
  readonly type = STOCK_COUNTS_PAGE_SIZE_UPDATE;
  logPayload = true;

  constructor(readonly payload: number) {}
}

export class StockCountsPageNumberUpdate implements Action {
  readonly type = STOCK_COUNTS_PAGE_NUMBER_UPDATE;
  logPayload = true;

  constructor(readonly payload: number) {}
}

export class StockCountsDetailLoadAction implements Action {
  readonly type = STOCK_COUNTS_DETAIL_LOAD;
  logPayload = true;

  ui = {
    id: STOCK_COUNTS_DETAIL,
    busy: true,
  };

  constructor(readonly payload: number) {}
}

export class StockCountsDetailLoadSuccessAction implements Action {
  readonly type = STOCK_COUNTS_DETAIL_LOAD_SUCCESS;

  ui = {
    id: STOCK_COUNTS_DETAIL,
    busy: false,
  };

  constructor(readonly payload: StockCountDetail) {}
}

export class StockCountsDetailLoadFailAction implements Action {
  readonly type = STOCK_COUNTS_DETAIL_LOAD_FAIL;
  logPayload = true;

  ui = {
    id: STOCK_COUNTS_DETAIL,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class StockCountsOrderListLoadAction implements Action {
  readonly type = STOCK_COUNTS_ORDER_LIST_LOAD;
  logPayload = true;

  ui = {
    id: STOCK_COUNTS_ORDER_LIST,
    busy: true,
  };

  constructor(readonly payload: string) {}
}

export class StockCountsOrderListLoadSuccessAction implements Action {
  readonly type = STOCK_COUNTS_ORDER_LIST_LOAD_SUCCESS;

  ui = {
    id: STOCK_COUNTS_ORDER_LIST,
    busy: false,
  };

  constructor(readonly payload: StockCountCreateOrderList) {}
}

export class StockCountsOrderListLoadFailAction implements Action {
  readonly type = STOCK_COUNTS_ORDER_LIST_LOAD_FAIL;
  logPayload = true;

  ui = {
    id: STOCK_COUNTS_ORDER_LIST,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class StockCountsMaterialListLoadAction implements Action {
  readonly type = STOCK_COUNTS_MATERIAL_LIST_LOAD;
  logPayload = true;

  ui = {
    id: STOCK_COUNTS_MATERIAL_LIST,
    busy: true,
  };

  constructor(readonly payload: GetStockCountMaterialList) {}
}

export class StockCountsMaterialListLoadSuccessAction implements Action {
  readonly type = STOCK_COUNTS_MATERIAL_LIST_LOAD_SUCCESS;

  ui = {
    id: STOCK_COUNTS_MATERIAL_LIST,
    busy: false,
  };

  constructor(readonly payload: { packingID: string, amount: number }[]) {}
}

export class StockCountsMaterialListLoadFailAction implements Action {
  readonly type = STOCK_COUNTS_MATERIAL_LIST_LOAD_FAIL;
  logPayload = true;

  ui = {
    id: STOCK_COUNTS_MATERIAL_LIST,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class StockCountsCreateAction implements Action {
  readonly type = STOCK_COUNTS_CREATE;
  logPayload = true;

  ui = {
    id: STOCK_COUNTS_CREATE_UI,
    busy: true,
  };

  constructor(readonly payload: TOstockCount) {}
}

export class StockCountsCreateSuccessAction implements Action {
  readonly type = STOCK_COUNTS_CREATE_SUCCESS;
  logPayload = true;

  ui = {
    id: STOCK_COUNTS_CREATE_UI,
    busy: false,
  };

  constructor(readonly payload: StockCountCreated) {}
}

export class StockCountsCreateFailAction implements Action {
  readonly type = STOCK_COUNTS_CREATE_FAIL;
  logPayload = true;

  ui = {
    id: STOCK_COUNTS_CREATE_UI,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class StockCountsShipToLoadAction implements Action {
  readonly type = STOCK_COUNTS_SHIPTO_LOAD;
  logPayload = true;

  ui = {
    id: STOCK_COUNTS_SHIPTO,
    busy: true,
  };

  constructor(readonly payload: string) {}
}

export class StockCountsShipToSuccessAction implements Action {
  readonly type = STOCK_COUNTS_SHIPTO_LOAD_SUCCESS;

  ui = {
    id: STOCK_COUNTS_SHIPTO,
    busy: false,
  };

  constructor(readonly payload: Definition[]) {}
}

export class StockCountsShipToFailAction implements Action {
  readonly type = STOCK_COUNTS_SHIPTO_LOAD_FAIL;
  logPayload = true;

  ui = {
    id: STOCK_COUNTS_SHIPTO,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class StockCountsCreateCanceled implements Action {
  readonly type = STOCK_COUNTS_CREATE_CANCELED;
}

export class StockCountsPrintLoadAction implements Action {
  readonly type = STOCK_COUNTS_PRINT_LOAD;

  ui = {
    id: STOCK_COUNTS_PRINT,
    busy: true,
  };

  constructor(readonly payload: string) {}
}

export class StockCountsPrintSuccessAction implements Action {
  readonly type = STOCK_COUNTS_PRINT_LOAD_SUCCESS;

  ui = {
    id: STOCK_COUNTS_PRINT,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class StockCountsPrintFailAction implements Action {
  readonly type = STOCK_COUNTS_PRINT_LOAD_FAIL;
  logPayload = true;

  ui = {
    id: STOCK_COUNTS_PRINT,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export type Actions =
  | StockCountsFilterValuesLoadAction
  | StockCountsFilterValuesLoadSuccessAction
  | StockCountsFilterValuesLoadFailAction
  | StockCountsPageSizeUpdate
  | StockCountsPageNumberUpdate
  | StockCountsDetailLoadAction
  | StockCountsDetailLoadSuccessAction
  | StockCountsDetailLoadFailAction
  | StockCountsOrderListLoadAction
  | StockCountsOrderListLoadSuccessAction
  | StockCountsOrderListLoadFailAction
  | StockCountsMaterialListLoadAction
  | StockCountsMaterialListLoadSuccessAction
  | StockCountsMaterialListLoadFailAction
  | StockCountsCreateAction
  | StockCountsCreateSuccessAction
  | StockCountsCreateFailAction
  | StockCountsShipToLoadAction
  | StockCountsShipToSuccessAction
  | StockCountsShipToFailAction
  | StockCountsCreateCanceled
  | StockCountsPrintLoadAction
  | StockCountsPrintSuccessAction
  | StockCountsPrintFailAction;
